import { createAsyncThunk } from '@reduxjs/toolkit';
import { CakeEdit } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { UpdateCakeDetailsRequest, UpdateCakeDetailsResponse } from './interface';

export const updateCakeDetails = createAsyncThunk(
  'cakeEdit/updateCakeDetails',
  async (request: UpdateCakeDetailsRequest, { rejectWithValue }) => {
    try {
          // Use the dedicated CakeEdit service
          const requestData = {
            ...request.cakeData,
            orderId: request.orderId, // Include the order ID in the request data
            names: request.names // Include names from frontend
          };
      
      console.log('Sending cake edit request with orderId:', request.orderId);
      
      const response = await CakeEdit.patch(request.orderCakeId, requestData);

      console.log('Cake details update response:', response);
      
      const updateResponse: UpdateCakeDetailsResponse = {
        success: response.success,
        message: response.message,
        data: response.data,
        newPrice: response.newPrice
      };

      return updateResponse;
    } catch (error: any) {
      console.error('Error updating cake details:', error);
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
